/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-19 21:33:54 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-28 16:24:18
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" />
    <div class="docs">
      <h1>{{ st('helpDocs.amazonAttributionModel.h1') }}</h1>

      <h2>{{ st('helpDocs.amazonAttributionModel.h2What') }}</h2>
      <p>{{ st('helpDocs.amazonAttributionModel.pWhat') }}</p>
      <h2>{{ st('helpDocs.amazonAttributionModel.h2Window') }}</h2>
      <ul>
        <li>{{ st('helpDocs.amazonAttributionModel.liW1') }}</li>
        <li>{{ st('helpDocs.amazonAttributionModel.liW2') }}</li>
      </ul>
      <h2>{{ st('helpDocs.amazonAttributionModel.h2Last') }}</h2>
      <ul>
        <li>{{ st('helpDocs.amazonAttributionModel.liL1') }}</li>
      </ul>
      <p>{{ st('helpDocs.amazonAttributionModel.pEx1Title') }}</p>
      <ul>
        <li>{{ st('helpDocs.amazonAttributionModel.liE1a') }}</li>
        <li>{{ st('helpDocs.amazonAttributionModel.liE1b') }}</li>
        <li>{{ st('helpDocs.amazonAttributionModel.liE1c') }}</li>
        <li>{{ st('helpDocs.amazonAttributionModel.liE1d') }}</li>
      </ul>
      <p>{{ st('helpDocs.amazonAttributionModel.pEx1Result') }}</p>
      <p>{{ st('helpDocs.amazonAttributionModel.pEx2Title') }}</p>
      <ul>
        <li>{{ st('helpDocs.amazonAttributionModel.liE2a') }}</li>
        <li>{{ st('helpDocs.amazonAttributionModel.liE2b') }}</li>
        <li>{{ st('helpDocs.amazonAttributionModel.liE2c') }}</li>
        <li>{{ st('helpDocs.amazonAttributionModel.liE2d') }}</li>
      </ul>
      <p>{{ st('helpDocs.amazonAttributionModel.pEx2Result') }}</p>
      <p>
        {{ st('helpDocs.amazonAttributionModel.pMore') }}
        <a
          href="https://advertising.amazon.com/library/guides/basics-of-amazon-attribution#01"
          target="_blank"
          >{{ st('helpDocs.amazonAttributionModel.aGuide') }}</a
        >.
      </p>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
</script>
